/**
 * PRP-MCP-8: the $7 chat trial checkout. Its own module because
 * `web/src/lib/api.ts` sits at its god-file ceiling (the `mcpApi.ts` precedent).
 * The backend answers 409 when the account has had a trial or a subscription,
 * with a message pointing to the plans; the shared `api` instance surfaces it
 * as `ApiError.message`.
 */
import { api } from './api';

export const ChatTrialAPI = {
  /** POST /billing/create-trial-session → the hosted Stripe Checkout URL. */
  createTrialSession: (): Promise<{ url: string }> =>
    api.post('/billing/create-trial-session', {}) as Promise<{ url: string }>,
};
